import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import { getFormByIdApi } from "../../../api/formsColaboradoresForms";
import { createProfileApi, getAllCollaboratorsApi } from "../../../api/formsColaboradoresProfiles";
import { TableCustom } from "../../../components/table";

const FormulariosColaboradoresPerfis = () => {
  const { id_cad_formularios } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);
  const [formulario, setFormulario] = useState({});

  useEffect(() => {
    if (id_cad_formularios) {
      getAllCollaborators(id_cad_formularios);
      getFormById(id_cad_formularios);
    }
  }, [id_cad_formularios]);

  const getFormById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getFormByIdApi(id);
      if (statusCode === 200) {
        if (!response.data) {
          navigate("/formularios-colaboradores/formularios");
        }
        setFormulario(response.data);
      } else {
        message.error(response.message);
        navigate("/formularios-colaboradores/formularios");
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
      navigate("/formularios-colaboradores/formularios");
    } finally {
      setLoading(false);
    }
  };

  const getAllCollaborators = async (form_id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllCollaboratorsApi(form_id);
      if (statusCode === 200) {
        setDados(response?.data.data);
        setSelected(response?.data.checked);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const createProfile = async (array_selected, array, form_id) => {
    setLoading(true);
    let array_collaborators = [];
    for (const el of array ?? []) array_collaborators.push(el.id);
    const data = {
      id_cad_formularios: form_id,
      id_colaborador: array_collaborators,
      id_colaborador_checked: array_selected,
    };

    try {
      const { response, statusCode } = await createProfileApi(data);
      if (statusCode === 200) {
        setSelected((array) => array.filter((el) => array_collaborators.indexOf(el) < 0));
        setSelected((el) => [...el, ...array_selected]);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Colaborador",
      dataIndex: "colaborador",
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Publicações" onClickBack={() => navigate("/formularios-colaboradores/formularios")} />
            <HeaderTitle
              title={["Formulários", "Perfis"]}
              subtitle={`Formulário - ${formulario.descricao}`}
              icon={<CheckCircleOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                selectedRows={selected}
                onRowChangeSelect={(array_selected, array_change, _) =>
                  createProfile(array_selected, array_change, id_cad_formularios)
                }
                isRowSelection={true}
                loading={loading}
                dataSource={dados}
                columns={columns}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};

export default FormulariosColaboradoresPerfis;
